"use strict";

export const getUploadFile = function(id) {
    return function () {
        var upload = document.getElementById(id);
        return upload.files[0];
    }
}
